import { Component } from '@angular/core';
import {ASSETS_API_URL} from "@app/app.constants";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss']
})
export class PageNotFoundComponent {
  public picturesServer = ASSETS_API_URL;
  constructor(public translateService: TranslateService) {}
}
